// extracted by mini-css-extract-plugin
export default {"answerButton":"answer-button_answerButton__+fpQ7","answerButtonContent":"answer-button_answerButtonContent__5uzrO"};